"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Branding API definition
 * Service to fetch MSO Branding Information.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: team-cumulus@xperi.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordingSpaceDisplay = void 0;
/**
 * Ways that clients can display recording space available. - hdAvailQuarterHours: Display the space available for HD recordings as decimal hours rounded down to quarter hours, e.g. 120.25 - usedSpacePercentage: Display the recording space available as a percentage of the total space.
 * @export
 * @enum {string}
 */
exports.RecordingSpaceDisplay = {
    HdAvailQuarterHours: 'hdAvailQuarterHours',
    UsedSpacePercentage: 'usedSpacePercentage'
};
